import * as React from 'react';
import styled from 'styled-components';

const Anchor = /*#__PURE__*/ React.forwardRef(function Anchor(inputProps, ref) {
    const { children , ...props } = inputProps;
    return /*#__PURE__*/ React.createElement("a", {
        ...props,
        ref: ref
    }, children);
});
const Button = /*#__PURE__*/ React.forwardRef(function Button(inputProps, ref) {
    const { children , ...props } = inputProps;
    return /*#__PURE__*/ React.createElement("button", {
        ...props,
        ref: ref
    }, children);
});
const ClickableView = ({ component , children , clickableRef , ...rest })=>{
    let Component;
    if (component) {
        Component = component;
    } else {
        Component = rest.href ? Anchor : Button;
    }
    return /*#__PURE__*/ React.createElement(Component, {
        ...rest,
        ref: clickableRef
    }, children);
};
const Clickable = styled(ClickableView).withConfig({
    displayName: "Clickable",
    componentId: "sc-be0034d4-0"
})`
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;

    line-height: normal;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    appearance: none;

    text-align: inherit;

    &::-moz-focus-inner {
        border: 0;
        padding: 0;
    }
`;

export { Clickable };
